module.exports = __webpack_public_path__ + "static/media/avatar.cbfcb712.svg";